// src/components/Signup.jsx
import React, { useState } from 'react';
import { logInWithGoogle, signUpWithEmail } from '../../firebase';
import '../Login/Login.css';

export default function Signup({ onToggleView }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState(''); // 1. Added phone state
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');
    
    if (password.length < 6) {
      return setError('Password must be at least 6 characters long.');
    }

    setIsLoading(true);
    
    try {
      // 2. Pass phone number into your signup function
      await signUpWithEmail(name, email, password, phone);
    } catch (err) {
      console.error(err);
      if (err.code === 'auth/email-already-in-use') {
        setError('An account with this email already exists.');
      } else {
        setError('Failed to create an account. Please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      {/* Left Pane */}
      <div className="login-left-pane">
        <div className="pane-overlay">
          <h2>Start Your Journey</h2>
          <p>Create an account to track your progress, unlock advanced modules, and master your subjects.</p>
        </div>
      </div>

      {/* Right Pane */}
      <div className="login-right-pane">
        <div className="login-form-container">
          
          <div className="login-header">
            <img src="/assets/icon.gif" alt="Logo" className="login-logo" />
            <h1>Create Account</h1>
            <p>Sign up to get started with GangaTricks.</p>
          </div>

          {error && <div className="login-error-alert">{error}</div>}

          <form onSubmit={handleSignup} className="login-form">
            <div className="input-group">
              <label htmlFor="name">Full Name *</label>
              <input 
                id="name"
                type="text" 
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Alex Student" 
                required 
              />
            </div>

            <div className="input-group">
              <label htmlFor="email">E-mail Address *</label>
              <input 
                id="email"
                type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email" 
                required 
              />
            </div>

            {/* 3. New Phone Number Input Field */}
            <div className="input-group">
              <label htmlFor="phone">Mobile Number *</label>
              <input 
                id="phone"
                type="tel" 
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="e.g. +1234567890" 
                required 
              />
            </div>
            
            <div className="input-group">
              <label htmlFor="password">Password *</label>
              <input 
                id="password"
                type="password" 
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Create a strong password" 
                required 
              />
            </div>

            <button type="submit" className="btn-primary" disabled={isLoading} style={{ marginTop: '10px' }}>
              {isLoading ? 'Creating account...' : 'Sign Up'}
            </button>
          </form>

          <div className="login-divider">
            <span>or sign up with</span>
          </div>

          <button onClick={logInWithGoogle} className="btn-google" type="button">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google Logo" />
            Sign up with Google
          </button>

          <div className="login-footer">
            Already have an account? <span onClick={onToggleView} style={{ color: '#2563eb', fontWeight: '600', cursor: 'pointer' }}>Sign In!</span>
          </div>

        </div>
      </div>
    </div>
  );
}